import React from 'react';
import './About.css';
import EditorChrome from './EditorChrome';

const About = () => (
    <main className="container portfolio-shell inner-shell">
        <EditorChrome active="/About" />
        <section id="about" className="inner-editor about-page">
            <a className="back-link" href="/">Back to homepage</a>
            <div className="page-heading">
                <p>;; Researcher, engineer, founder, and educator</p>
                <h1>About Me</h1>
                <span>Electrical and computer engineering across signals, learning systems, and real-world devices.</span>
            </div>

            <div className="about-layout">
                <article className="about-copy">
                    <p>I am a PhD candidate in Electrical and Computer Engineering at Curtin University, specialising in machine learning, acoustic signal processing, and multichannel biosignal analysis.</p>
                    <p>My research focuses on deep learning for cardiovascular disease detection, including multichannel PCG/ECG processing, contrastive representation learning, and generative augmentation. I work with Conformers, Wav2Vec 2.0, VAE and GAN encoders, diffusion models, flow matching, and custom multichannel DSP pipelines.</p>
                    <p>I am also the co-founder of BIRDRONE, where I develop autonomous AI-powered sensing systems that combine low-cost sensor arrays, embedded processing, and drone robotics for orchard monitoring and bird deterrence.</p>
                    <p>Alongside BIRDRONE and my research, I undertake contract engineering for companies including Ticking Heart and PlantSpeak. This spans audio DSP, applied ML, embedded development, full-stack tooling, and product-focused sensing systems.</p>
                    <p>At Curtin University, I am a sessional academic tutoring computing, software engineering, DSP, C and Unix systems, algorithms, electronics, and embedded systems.</p>
                    <p>My broader interests include audio ML, speech enhancement, multimodal generative models, PCB design, robotics, and full-stack development. I enjoy building complete systems—from biosignal classifiers and JUCE effects to drone control software and complex web applications.</p>
                </article>

                <aside className="about-sidebar">
                    <div>
                        <span>Current role</span>
                        <strong>PhD Candidate</strong>
                        <p>Curtin University</p>
                    </div>
                    <div>
                        <span>Primary fields</span>
                        <strong>DSP · ML · Embedded</strong>
                        <p>Audio, biosignals, sensing, robotics</p>
                    </div>
                    <div className="about-documents">
                        <span>Documents</span>
                        <a className="btn" href="/Documents/Resume.pdf" target="_blank" rel="noreferrer">Résumé</a>
                        <a className="btn" href="/Documents/CV.pdf" target="_blank" rel="noreferrer">Full Curriculum Vitae</a>
                        <a className="btn" href="/Documents/LaTeX-source.zip" download>LaTeX sources</a>
                        <a className="btn" href="/Documents/transcript.pdf" target="_blank" rel="noreferrer">Academic Transcript</a>
                    </div>
                </aside>
            </div>
        </section>
    </main>
);

export default About;
